/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { XIcon } from "lucide-react";
import { createPortal } from "react-dom";
import { SingleDocumentUpload } from "./single-document-upload";
import { useEffect, useState } from "react";
import { apiServices } from "@/services/api.services";
import { retailers } from "@/services/global.services";
import { useProcess } from "@/global-data";
// import { MultiDocumentUpload } from "./multi-document-upload";
import { useToast } from "@/hooks/use-toast";

export const DocumentUploadDetailsForm = ({
  formData,
  onOpenChange,
  onFormSubmit,
  open,
  workflowList,
  currentCompanyData,
  company_id,
  user_id,
  // allRetailerList,
}: any) => {
  // const supportMultiDocType = currentCompanyData?.settings
  //   ?.support_multi_doc_type
  //   ? true
  //   : false;
  const { setProcess } = useProcess();

  const { toast } = useToast();

  const [allRetailerList, setAllRetailerList] = useState([]);
  const loadingRetailer = async () => {
    const payload = {
      data: {
        filter_by: {
          search_text: "",
          exact_match: false,
          list_customer_name: true,
        },
      },
      company_id: company_id,
      user_id: user_id,
    };
    const { data, error, message } = await apiServices<any>(
      retailers.get,
      "post",
      payload,
    );

    if (data) {
      setAllRetailerList(data.result.metadata?.[retailers.key]);
    }

    if (error) {
      toast({
        title: "Error",
        variant: "destructive",
        description: error.status?.message || message,
      });
    }
    return { data, error };
  };

  useEffect(() => {
    (async () => {
      if (open) {
        setProcess(true);
        await loadingRetailer();
        setProcess(false);
      }
    })();
  }, [open]);

  return createPortal(
    <div className="fixed left-0 top-0 w-full h-full bg-black/50 flex justify-center items-center z-[99]">
      <div className="bg-white w-[65%] rounded-md flex flex-col relative">
        <div className="justify-between items-center w-full flex border border-l-0 border-r-0 border-t-0 px-6 py-2 mb-3 pr-2">
          <h3 className="text-md font-bold">Upload Document</h3>
          <Button variant={"ghost"} onClick={() => onOpenChange(false)}>
            <XIcon />
          </Button>
        </div>
        {/* {supportMultiDocType ? (
          <MultiDocumentUpload
            currentCompanyData={currentCompanyData}
            formData={formData}
            onFormSubmit={onFormSubmit}
            onOpenChange={onOpenChange}
            open={open}
            workflowList={workflowList}
          />
        ) : (
          <SingleDocumentUpload
            currentCompanyData={currentCompanyData}
            formData={formData}
            onFormSubmit={onFormSubmit}
            onOpenChange={onOpenChange}
            open={open}
            workflowList={workflowList}
          />
        )} */}
        <SingleDocumentUpload
          currentCompanyData={currentCompanyData}
          formData={formData}
          onFormSubmit={onFormSubmit}
          onOpenChange={onOpenChange}
          open={open}
          workflowList={workflowList}
          allRetailerList={allRetailerList}
        />
        {/* <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="flex flex-col gap-x-6 gap-y-5 px-6">
              <FormField
                control={form.control}
                name="file_path"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>
                      Upload
                      <RequiredInput />
                    </FormLabel>
                    <FormControl>
                      <UploadInputV2
                        placeholder="File Path"
                        value={field.value}
                        onChange={field.onChange}
                      />
                    </FormControl>

                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormField
                control={form.control}
                name="workflow_id"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>
                      Workflow
                      <RequiredInput />
                    </FormLabel>
                    <FormControl>
                      <SelectWithSearch
                        bindLabel="name"
                        bindValue="workflow_id"
                        placeholder="Select Workflow"
                        options={workflowList}
                        value={field.value}
                        onChange={field.onChange}
                        onBlur={field.onBlur}
                      />
                    </FormControl>
                    <FormMessage />
                  </FormItem>
                )}
              />
              {supportMultiDocType ? (
                <FormField
                  control={form.control}
                  name="document_type"
                  render={({ field }) => (
                    <FormItem>
                      <FormLabel>
                        Document type
                        <RequiredInput />
                      </FormLabel>
                      <FormControl>
                        <SelectWithSearch
                          bindLabel="label"
                          bindValue="value"
                          placeholder="Document type"
                          options={[
                            {
                              label: "daily_sales_report",
                              value: "daily_sales_report",
                            },
                            {
                              label: "bank_deposit_slip",
                              value: "bank_deposit_slip",
                            },
                            {
                              label: "pos_payout_receipt",
                              value: "pos_payout_receipt",
                            },
                            {
                              label: "payout_invoice",
                              value: "payout_invoice",
                            },
                          ]}
                          value={field.value}
                          onChange={field.onChange}
                          onBlur={field.onBlur}
                        />
                      </FormControl>
                      <FormMessage />
                    </FormItem>
                  )}
                />
              ) : null}
            </div>

            <div className="mt-10 px-6 py-4 flex gap-5 w-full border border-r-0 border-l-0 border-b-0">
              <Button
                type="submit"
                className="w-[120px]"
                disabled={form.formState.isSubmitting}
              >
                {form.formState.isSubmitting ? (
                  <IconRender
                    name="LoaderCircle"
                    className="w-5 animate-spin text-white zoom-in-150"
                  />
                ) : (
                  "Submit"
                )}
              </Button>
              <Button
                type="submit"
                onClick={() => onOpenChange(false)}
                variant={"outline"}
                className="w-[120px]"
              >
                Close
              </Button>
            </div>
          </form>
        </Form> */}
      </div>
    </div>,
    document.body,
  );
};
